/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectFinancialClaimsDetailsCommand } from '../../models/update-project-financial-claims-details-command';
import { UpdateProjectFinancialClaimsDetailsCommandResult } from '../../models/update-project-financial-claims-details-command-result';

export interface ApiProjectFinancialClaimsDetailsPut$Params {
  
    /**
     * Updated details of the Project Financial Claim to apply.
     */
    body?: UpdateProjectFinancialClaimsDetailsCommand
}

export function apiProjectFinancialClaimsDetailsPut(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialClaimsDetailsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectFinancialClaimsDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialClaimsDetailsPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectFinancialClaimsDetailsCommandResult>;
    })
  );
}

apiProjectFinancialClaimsDetailsPut.PATH = '/api/ProjectFinancialClaimsDetails';
